<template>
	<v-container grid-list-md>
		<v-card>
			<v-toolbar dense>
				<v-toolbar-items>
					<Link
						as="v-btn"
						:key="index"
						:href="
							$route(
								'tenant.reports.' + tab.value,
								$page.props.tenant.id
							)
						"
						v-for="(tab, index) in tabs"
						:input-value="
							$route().current(
								'tenant.reports.' + tab.value,
								$page.props.tenant.id
							)
						"
						text
					>
						{{ tab.text }}
					</Link>
				</v-toolbar-items>
			</v-toolbar>
			<v-card-text class="pa-0">
				<slot />
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
export default {
	components: {
		Link,
	},
	data() {
		return {
			tab: 0,
			tabs: [
				{ text: this.$t("label.statistic"), value: "index" },
				{ text: this.$t("label.daily"), value: "daily" },
				{ text: this.$t("label.monthly"), value: "monthly" },
				{ text: this.$t("Outlet"), value: "outlet" },
				{ text: this.$t("label.chart"), value: "chart" },
			],
		};
	},
};
</script>